import { NgModule } from '@angular/core';

import { KeysPipe } from './keys.pipe';
import { GetByIdPipe } from './getById.pipe';
import { HtmlToPlaintextPipe } from './htmlToPlaintext.pipe';
import { FilterPipe } from './filter.pipe';
import { CamelCaseToDashPipe } from './camelCaseToDash.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';
import { SubEventPriorityPipe } from './sub-event-priority.pipe';
import {HubColumnCheckPipe} from './hubColumnCheck.pipe';

@NgModule({
    declarations: [
        KeysPipe,
        GetByIdPipe,
        HtmlToPlaintextPipe,
        FilterPipe,
        CamelCaseToDashPipe,
        SafeHtmlPipe,
      SubEventPriorityPipe,
      HubColumnCheckPipe

    ],
    imports     : [],
    exports     : [
        KeysPipe,
        GetByIdPipe,
        HtmlToPlaintextPipe,
        FilterPipe,
        CamelCaseToDashPipe,
        SafeHtmlPipe,
      SubEventPriorityPipe,
      HubColumnCheckPipe
    ]
})

export class FusePipesModule
{

}
